// PowerSync — авто-словарь терминов (glossary_terms).
//
import { usePowerSyncQuery } from "@/lib/powersync/use-query";
import { belongsToLiveMaterial } from "../live-material-sql";

export interface LocalGlossaryTerm {
	id: string;
	user_id: string;
	material_id: string | null;
	set_id: string | null;
	/** Термин темы курса (миграция 0083): material_id = NULL, привязка через тему. */
	subsection_id: string | null;
	term: string;
	definition: string;
	language: string | null;
	citations: string | null; // jsonb
	examples: string | null; // jsonb
	cross_references: string | null; // jsonb
	occurrences: number | null;
	importance: string | null;
	status: string | null;
	sort_order: number | null;
	generated_by_ai: number; // bool
	ai_model: string | null;
	prompt_version: string | null;
	generation_trace_id: string | null;
	user_edited: number; // bool
	user_verified: number; // bool
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
}

export function useGlossaryByMaterialQuery(
	materialId: string | undefined,
	sortBy: "alpha" | "importance" | "frequency" = "alpha",
) {
	const orderClause = sortBy === "alpha" ? "ORDER BY LOWER(term) ASC" : "ORDER BY updated_at DESC";
	return usePowerSyncQuery<LocalGlossaryTerm>(
		`SELECT * FROM glossary_terms
		   WHERE material_id = ? AND deleted_at IS NULL
		${orderClause}`,
		[materialId ?? ""],
	);
}

export function useGlossaryForUserQuery(userId: string | undefined) {
	// Термин удалённого материала не показывается. Сервер гасит такие термины
	// каскадом (`trash/cascade-material-artifacts.ts`), но каскад доезжает до
	// клиента только после upload'а tombstone'а материала — до этого момента
	// раздел показывал термины уже удалённого источника. Предикат общий с
	// бейджем навигации, см. `live-material-sql`.
	return usePowerSyncQuery<LocalGlossaryTerm>(
		`SELECT g.* FROM glossary_terms g
		   WHERE g.user_id = ? AND g.deleted_at IS NULL AND ${belongsToLiveMaterial("g")}
		ORDER BY LOWER(g.term) ASC`,
		[userId ?? ""],
	);
}
